import React, {useState, useEffect, useCallback} from 'react'
import style from './policy.module.sass'
import {Modal} from '../../../helpers/commonUi'
import {Select, Spin, Icon} from 'antd'
import {Http} from '../../../helpers/axois'
import {useToast} from '../../../helpers/commonFunction/useToast'
import {ReactComponent as DeleteIcon} from '../../../assets/svg/deleteX.svg'

const {Option} = Select
const antIcon = <Icon type="loading" style={{fontSize: 24}} spin />;

export const AddPolicyModal = (props: any) => {
    const [policyList, setPolicyList] = useState<any[]>([])
    const [selectedPolicyList, setSelectedPolicyList] = useState<any[]>([])
    const {orgId, from, data, policyModalVisible, setPolicyModalVisible, setPolicyState} = props;
    const {canAttach, canRemove} = data
    const [isPolicyLoading, setPolicyLoading] = useState(false)
    const [isItemPolicyLoading, setItemPolicyLoading] = useState(false)
    const [isLoading, setLoading] = useState(false)

    const id = (props.from === 'team' && data) ? data.id : data.usr_id
    const From = `${from.slice(0, 1).toUpperCase()}${from.slice(1,)}`
    const {ErrorToast} = useToast()

    const getPolicy = useCallback(() => {
        Http.get(`/policy?orgId=${orgId}`).subscribe((res: any) => {
            setPolicyLoading(false)
            setPolicyList(res)
        }, (err) => {
            setPolicyLoading(false)
            ErrorToast('Error fetching policies')
        })
    }, [orgId, ErrorToast])

    useEffect(() => {
        setPolicyLoading(true)
        getPolicy()
    }, [getPolicy])

    const fetchData = useCallback(() => {
        Http.get(`/${from}Policy/${id}?orgId=${orgId}`).subscribe((res: any) => {
            setItemPolicyLoading(false)
            setSelectedPolicyList(res)
        }, (err: any) => {
            setItemPolicyLoading(false)
            ErrorToast(`Error fetching ${from} policies`)
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id, orgId])

    useEffect(() => {
        if (policyModalVisible) {
            setItemPolicyLoading(true)
            fetchData()
        }
    }, [policyModalVisible, fetchData])

    const addPolicy = (policyId: any) => {
        setLoading(true);
        Http.post(`/add${From}Policy`, {
            [`${from}Id`]: id,
            policyId: policyId,
            orgId: orgId
        }).subscribe((res) => {
            setLoading(false)
            setItemPolicyLoading(true)
            fetchData()
            setPolicyState(true);
        }, (err) => {
            setLoading(false)
            ErrorToast('Error adding policy')
        })
    }

    const removePolicy = (policyId: any) => {
        setLoading(true);
        Http.delete(`/remove${From}Policy/${policyId}?orgId=${orgId}`).subscribe((res) => {
            setLoading(false)
            setItemPolicyLoading(true)
            fetchData()
            setPolicyState(true);
        }, (err) => {
            setLoading(false)
            ErrorToast('Error deleting policy')

        })
    }

    return (
        <Modal
            id="addPolicies"
            dataTestId="add_policies"
            unmountOnCancel={true}
            visible={policyModalVisible}
            title="ADD POLICIES"
            onCancel={() => {
                setPolicyModalVisible(false);
            }}
            footer={{
                enable: false
            }}
        >
            <div className={style.policyModalContainer}>
                <div className={style.fieldTitle}>Policy :</div>
                <Select data-test-id="select_policy" onChange={(value: any) => {
                    if (canAttach) {
                        addPolicy(value)
                    } else {
                        ErrorToast(`You are not authorized to add policies to this ${props.from}`)
                    }
                }} value='' style={{width: '100%'}} loading={(isPolicyLoading && isItemPolicyLoading)}>
                    {
                        policyList.map((policy: any) => {
                            const isPresent = selectedPolicyList.find((item: any) => item.policies_id === policy.id_) ? true : false
                            return <Option data-test-id={`${policy.name}`} disabled={isPresent} key={policy.id_} value={policy.id_}>{policy.name}</Option>
                        })
                    }
                </Select>
                {
                    isItemPolicyLoading ?
                        <div style={{display: 'flex', justifyContent: 'center', marginTop: '16px'}}>
                            <Spin indicator={antIcon} style={{ color: '#15808C' }} />
                        </div>
                        :
                        <div style={{display: 'flex', flexWrap: 'wrap', paddingTop: '8px'}}>
                            {
                                selectedPolicyList.map((policy: any) => {
                                    const policyInfo = policyList.find((item: any) => item.id_ === policy.policies_id)
                                    return (
                                        <div data-test-id={`${policy.id_}`} key={policy.id_} className={style.policyCardContainer}>
                                            {policyInfo && policyInfo.name}
                                            <DeleteIcon data-test-id="delete" onClick={() => {
                                                if (canRemove) {
                                                    removePolicy(policy.id_)
                                                } else {
                                                    ErrorToast(`You are not authorized to remove policies from this ${props.from}`)
                                                }
                                            }} height="20px" width="20px" />
                                        </div>
                                    )
                                })
                            }
                        </div>
                }
                {
                    isLoading ?
                        <div data-test-id="loading" onClick={(e: any) => e.stopPropagation()} style={{display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'absolute', top: 0, left: 0, height: '100%', width: '100%', background: '#0000004A'}}>
                            <Spin indicator={antIcon} style={{ color: '#15808C' }} />
                        </div>
                        :
                        null
                }
            </div>
        </Modal>
    )
}
